import { Dispatch } from "redux";
import api from "../../api/api";
import {
    resetTeacherDetails,
    setTeacherDetails,
    seterror,
    setloading,
} from "../reducers/getTeacherByTeacherIdReducer";

const getTeacherDetails = (id: any, token: any) => async (
    dispatch: Dispatch
) => {
    dispatch(setloading(true));
    try {
        const result = await api.get(`/auth/get-teacher-by-teacher-id/${id}/`, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {
            dispatch(setloading(false));
            if (result.data?.status === 200) {
                dispatch(setTeacherDetails(result.data));
            } else {
                dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    } catch (error: any) {
        dispatch(seterror(error.response.data.message));
    }
};

export { getTeacherDetails, resetTeacherDetails };

